import { render, staticRenderFns } from "./BookingTicketsList.vue?vue&type=template&id=63b5e2fa"
import script from "./BookingTicketsList.vue?vue&type=script&lang=js"
export * from "./BookingTicketsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports